import mixpanel from 'mixpanel-browser';

try
{
  const key = process.env.REACT_APP_MIX_PANEL_KEY;

  if (key)
  {
    mixpanel.init(key,
    {
      autocapture: true,
      // debug: false,
      record_sessions_percent: 100,
      debug: process.env.NODE_ENV === 'Live',
    });
  }
}
catch (err)
{
  //console.warn('Mixpanel failed:', err);
}

export default mixpanel;